// assets/mobile-view-manager.js
class MobileViewManager {
  constructor() {
    this.config = window.shopifyMobileView || {};
    this.init();
  }

  async init() {
    // Set cart attribute if view=mobile in URL
    if (this.config.shouldSetAttribute) {
      await this.setMobileViewAttribute();
    }

    // Bind events for future navigation
    if (this.config.isActive) {
      this.ensureMobileParam();
    }
    this.bindEvents();
  }

  async setMobileViewAttribute() {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 'view': 'mobile' }
        })
      });
    } catch (error) {
      console.error('Failed to set mobile view attribute:', error);
    }
  }

  isMobileViewParam(view) {
    if (!view) return false;
    return view === 'mobile' || view.startsWith('mobile-') || view.includes('mobile') || view === 'product-mobile';
  }

  ensureMobileParam() {
    const url = new URL(window.location);
    const view = url.searchParams.get('view');
    
    if (!this.isMobileViewParam(view)) {
      if(location.pathname?.includes('location')){
        url.searchParams.set('view', 'mobile-location');
      }else if(location.pathname?.includes('mobile-search') || location.pathname?.includes('search')){
        url.searchParams.set('view', 'mobile-search');
      }else if(location.pathname?.includes('subscriptions')){
        url.searchParams.set('view', 'mobile-subscriptions');
      }else if(location.pathname?.includes('/account/login')){
        url.searchParams.set('view', 'mobile-login');
      }else if(location.pathname?.includes('/account/register')){
        url.searchParams.set('view', 'mobile-register');
      }else if(location.pathname?.includes('/products/')){
        url.searchParams.set('view', 'product-mobile');
      }else {
        url.searchParams.set('view', 'mobile');
      }
      
      // Smooth transition without glitch
      this.smoothRedirect(url.toString());
    }
  }

  smoothRedirect(newUrl) {
    // Prevent multiple redirects
    if (this.redirecting) return;
    if (window.location.href === newUrl) return;
    this.redirecting = true;

    // Add loading state
    document.body.style.opacity = '0.98';
    document.body.style.transition = 'opacity 0.1s ease';

    // Redirect after brief delay to prevent flash
    setTimeout(() => {
      window.location.href = newUrl;
    }, 50);
  }

  bindEvents() {
    // Handle all link clicks
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;
      const href = link.getAttribute('href');
      if (this.isInternalLink(href)) {
        e.preventDefault();
        this.navigateWithMobileParam(href);
      }
    });
  }

  isInternalLink(href) {
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return false;
    }
    
    try {
      const url = new URL(href, window.location.origin);
      return url.origin === window.location.origin;
    } catch {
      return href.startsWith('/');
    }
  }

  navigateWithMobileParam(href) {
    try {
      const url = new URL(href, window.location.origin);
      const existingView = url.searchParams.get('view');

      if (!this.isMobileViewParam(existingView)) {
        if(href?.includes('location')){
          url.searchParams.set('view', 'mobile-location');
        }else if(href?.includes('mobile-search') || href?.includes('search')){
          url.searchParams.set('view', 'mobile-search');
        }else if(href?.includes('subscriptions')){
          url.searchParams.set('view', 'mobile-subscriptions');
        }else if(href?.includes('/account/login')){
          url.searchParams.set('view', 'mobile-login');
        }else if(href?.includes('/account/register')){
          url.searchParams.set('view', 'mobile-register');
        }else if(href?.includes('/products/')){
          url.searchParams.set('view', 'product-mobile');
        }else {
          url.searchParams.set('view', 'mobile');
        }
      }
      
      window.location.href = url.toString();
    } catch {
      const separator = href.includes('?') ? '&' : '?';
      let viewMode = 'view=mobile';
      if(href?.includes('location')){
        viewMode = 'view=mobile-location';
      }else if(href?.includes('mobile-search') || href?.includes('search')){
        viewMode = 'view=mobile-search';
      }else if(href?.includes('subscriptions')){
        viewMode = 'view=mobile-subscriptions';
      }else if(href?.includes('/account/login')){
        viewMode = 'view=mobile-login';
      }else if(href?.includes('/account/register')){
        viewMode = 'view=mobile-register';
      }else if(href?.includes('/products/')){
        viewMode = 'view=product-mobile';
      }
      window.location.href = `${href}${separator}${viewMode}`;
    }
  }
}

// Initialize when DOM is ready
if (window.shopifyMobileView) {
  document.addEventListener('DOMContentLoaded', () => {
    new MobileViewManager();
  });
}